






















































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';
import SpecOutDto from '@/models/SpecOuts/SpecOutDto';
import UpdateSpecOutEmailDetailsRequest from '@/models/SpecOuts/UpdateSpecOutEmailDetailsRequest';
import EmailTemplateType from '@/models/EmailTemplates/EmailTemplateType';
import EmailTemplateDto from '@/models/EmailTemplates/EmailTemplateDto';

@Component({
    name: 'SpecOutEmailDetailsEdit'
})
export default class SpecOutEmailDetailsEdit extends GiganautVueDialog {

  entity: SpecOutDto = new SpecOutDto();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(SpecOutDetailsModule.currentSpecOut));
      await AgencySettingsModule.getEmailTemplates();
    }
  }

  get filteredEmailTemplates() {
    return AgencySettingsModule.emailTemplates.filter(
      (t: EmailTemplateDto) => t.type === EmailTemplateType.ContactWorkerSendOut
    );
  }

  get loading() {
    return SpecOutDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new UpdateSpecOutEmailDetailsRequest();
    request.updatedAt = this.entity.updatedAt;
    request.emailTemplateId = this.entity.emailTemplate.id;
    request.emailBccUser = this.entity.emailBccUser;
    request.isTest = this.entity.isTest;
    request.testEmailAddresses = this.entity.testEmailAddresses;

    await SpecOutDetailsModule.editSpecOutEmailDetails(request);
    this.dialog = false;
  }
}
